import { shareMessage, shareURL } from "@telegram-apps/sdk"
import * as m from "@/paraglide/messages"
import { env } from "@/shared/config/env"
import { getLocale, type Locale } from "@/shared/lib/i18n"
import { detectPlatform, shareFileNative } from "@/shared/lib/platform"
import { REFERRAL_SERVICE_URL } from "./constants"
import { inviteBotStartUrl } from "./invite-bot-url"

const INVITE_CARDS: Record<Locale, () => Promise<{ default: string }>> = {
	ru: () => import("../assets/card-ru.webp"),
	en: () => import("../assets/card-en.webp"),
	es: () => import("../assets/card-es.webp"),
}

async function loadInviteCardBlob(): Promise<Blob> {
	const card = await INVITE_CARDS[getLocale()]()
	return fetch(card.default).then((r) => r.blob())
}

export async function openInviteLink(
	tgRefCode: string,
	tgInviteMessageId: string | null | undefined,
): Promise<void> {
	const platform = detectPlatform()
	const inviteText = m.inviteShareText()

	if (platform === "telegram") {
		const bot = env.VITE_PUBLIC_TG_BOT_USERNAME
		if (!bot) {
			console.error("VITE_PUBLIC_TG_BOT_USERNAME is not configured")
			return
		}
		const shareLink = () =>
			shareURL.ifAvailable(inviteBotStartUrl(bot, tgRefCode), inviteText)
		// id заранее подготовленного inline-сообщения — шарим фото-карточку нативным диалогом Telegram.
		if (tgInviteMessageId && shareMessage.isAvailable()) {
			shareMessage(tgInviteMessageId).catch((err) => {
				console.error("shareMessage failed, fallback to shareURL:", err)
				shareLink()
			})
			return
		}
		// Fallback: текст + ссылка (shareMessage недоступен / упал).
		shareLink()
		return
	}

	if (platform === "ios" || platform === "android") {
		const text = `${inviteText}${REFERRAL_SERVICE_URL}/invite/${tgRefCode}`
		const blob = await loadInviteCardBlob()
		await shareFileNative({ blob, fileName: "invite-card.webp", text }).catch(
			console.error,
		)
		return
	}

	console.error("openInviteLink: unsupported platform", platform)
}
